<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { fetchRoomDescription } from '../services/roomApi';

const props = defineProps<{
  room: string;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const description = ref<string>('Lädt Raumbeschreibung...');
const isLoading = ref(true);
const error = ref<string | null>(null);

onMounted(async () => {
  try {
    isLoading.value = true;
    error.value = null;
    description.value = await fetchRoomDescription(props.room);
  } catch (e) {
    error.value = 'Fehler beim Laden der Raumbeschreibung';
    console.error('Error loading room description:', e);
  } finally {
    isLoading.value = false;
  }
});
</script>

<template>
  <div class="modal-overlay" @click="emit('close')">
    <div class="modal-content" @click.stop>
      <h3>Wegbeschreibung</h3>
      <div v-if="isLoading" class="loading">
        Lädt Raumbeschreibung...
      </div>
      <div v-else-if="error" class="error">
        {{ error }}
      </div>
      <p v-else>{{ description }}</p>
      <button @click="emit('close')">Schließen</button>
    </div>
  </div>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 90%;
  width: 400px;
}

button {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background: #960040;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

h3 {
  color: #960040;
  margin-bottom: 1rem;
}

p {
  white-space: pre-line;
  color: #333;
  line-height: 1.5;
}

.loading {
  color: #666;
  text-align: center;
  padding: 1rem 0;
}

.error {
  color: #dc2626;
  text-align: center;
  padding: 1rem 0;
}
</style>